import { createFileRoute, Link } from "@tanstack/react-router";
import financiacionAsset from "@/assets/financiacion-castillamancha.png.asset.json";
import cartelAsset from "@/assets/cartel-fie-jccm.webp.asset.json";
import cartelPdfAsset from "@/assets/cartel-fie-jccm.pdf.asset.json";

export const Route = createFileRoute("/financiacion")({
  head: () => ({
    meta: [
      {
        title:
          "Proyecto financiado por Castilla-La Mancha y la Unión Europea · El Pajar de Benito",
      },
      {
        name: "description",
        content:
          "El Pajar de Benito es empresa beneficiaria de las subvenciones de la Junta de Comunidades de Castilla-La Mancha (Ayudas –Adelante Inversión–), cofinanciado por el Fondo Europeo de Desarrollo Regional.",
      },
      {
        property: "og:title",
        content:
          "Proyecto financiado por Castilla-La Mancha y la Unión Europea",
      },
      {
        property: "og:description",
        content:
          "Empresa beneficiaria de las subvenciones de la Junta de Comunidades de Castilla-La Mancha: Ayudas –Adelante Inversión–, cofinanciadas por el Fondo Europeo de Desarrollo Regional.",
      },
      {
        property: "og:url",
        content: "https://elpajardebenito.es/financiacion",
      },
      { property: "og:type", content: "article" },
    ],
    links: [
      { rel: "canonical", href: "https://elpajardebenito.es/financiacion" },
    ],
  }),
  component: FinanciacionPage,
});

function FinanciacionPage() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-16 md:py-24">
      <p className="text-xs uppercase tracking-[0.28em] text-accent">Subvenciones</p>
      <h1 className="mt-4 font-serif text-3xl text-foreground md:text-4xl">
        Proyecto financiado por Castilla-La Mancha y la Unión Europea
      </h1>
      <div className="mt-8 space-y-4 leading-relaxed text-muted-foreground">
        <p>
          Empresa beneficiaria de las subvenciones de la Junta de Comunidades de
          Castilla-La Mancha: <strong>Ayudas –Adelante Inversión–</strong> para el
          fomento de la inversión y la mejora de la productividad empresarial.
        </p>
        <p>
          Proyecto incentivado con una subvención cofinanciada por el{" "}
          <strong>Fondo Europeo de Desarrollo Regional</strong>.
        </p>
        <p>
          Objetivo del proyecto:{" "}
          <strong>Conseguir un tejido empresarial más competitivo</strong>.
        </p>
      </div>
      <div className="mt-10 rounded-sm border border-border bg-background p-4 shadow-sm">
        <img
          src={cartelAsset.url}
          alt="Cartel oficial del proyecto financiado por el Fondo Europeo de Desarrollo Regional y la Junta de Comunidades de Castilla-La Mancha (Ayudas Adelante Inversión)"
          width={1200}
          height={1697}
          className="w-full rounded-sm"
        />
        <div className="mt-4 text-center">
          <a
            href={cartelPdfAsset.url}
            target="_blank"
            rel="noopener"
            className="inline-block text-sm font-medium text-primary hover:text-primary/80"
          >
            Descargar cartel en PDF ↓
          </a>
        </div>
      </div>
      <div className="mt-6 rounded-sm border border-border bg-background p-4 shadow-sm">
        <img
          src={financiacionAsset.url}
          alt="Certificado de financiación del proyecto por la Junta de Comunidades de Castilla-La Mancha y el Fondo Europeo de Desarrollo Regional"
          width={1200}
          height={800}
          className="w-full rounded-sm"
        />
      </div>
      <div className="mt-8">
        <Link
          to="/"
          className="text-sm font-medium text-primary hover:text-primary/80"
        >
          ← Volver al inicio
        </Link>
      </div>
    </div>
  );
}
